import RegisterAPI from "@/config/api/register";
import TransferAPI from "@/config/api/transfer";
import { APIError } from "@/utils/Error";
import { ENCRYPTION_VERSION, ID_TYPE, USER_TYPE } from "@/utils/Constants";
import CommonUtil from "@/utils/CommonUtil";
import EncryptionUtil from "@/utils/EncryptionUtil";
import commonUtil from "@/utils/CommonUtil";

export default {
  state: {
    serviceIdType: "",
    common: {
      session_key: "",
      session_token: "",
      is_app_judgment: false,
      birth: "",
      is_parent_person: false,
      is_service: false
    },
    userType: {
      list: [],
      selected: ""
    },
    term: {
      integration: [],
      service: [],
      hasAgeLimit: undefined
    },
    account: {
      method: "",
      id: "",
      password: "",
      country_number: "",
      social_data: {},
      service_information: {},
      birth: "",
      email: "",
      phone: "",
      parentPhone: "",
      parentName: "",
      is_multi: false,
      muti_account_list: [], //0: 핸드폰, 1: 이메일 순으로 담김,
      under_age: false,
      nickname: ""
    },
    transfer: {
      id: "",
      method: ""
    },
    isTeacher: false,
    duplicationInfo: {
      id_type: "",
      id: "",
      etoos_id: "",
      register_date: 0
    } // Di-ON 앱에서 통합회원 로그인 화면 호출 시 queryString값 존재여부로 강사 회원유형 노출 여부 판단
  },
  mutations: {
    // 회원가입 정보 초기화
    ALL_REGISTER_INIT(state) {
      state.common.session_key = "";
      state.common.session_token = "";
      state.common.birth = "";
      state.common.is_parent_person = false;
      state.common.is_service = false;

      state.term.integration = [];
      state.term.service = [];
      state.term.hasAgeLimit = undefined;

      state.account.method = "";
      state.account.id = "";
      state.account.password = "";
      state.account.country_number = "";
      state.account.social_data = {};
      state.account.service_information = {};
      state.account.birth = "";
      state.account.email = "";
      state.account.phone = "";
      state.account.parentPhone = "";
      state.account.parentName = "";
      state.account.is_multi = false;
      state.account.muti_account_list = [];
      state.transfer.id = "";
      state.transfer.method = "";

      state.userType.list = [];
      state.userType.selected = "";
    },
    // 세션 정보 초기화
    INIT_SESSION(state) {
      state.common.session_key = "";
      state.common.session_token = "";
    },
    // 세션 정보 설정
    SET_SESSION_KEY(state, response) {
      state.common.session_key = response.session_key;
      state.common.is_app_judgment = response.is_app_judgment ?? false;
      state.common.is_service = response.hasService;
    },
    // 전환 유저의 정보 설정
    SET_TRANSFER_USER_INFO(state, response) {
      state.common.session_token = response.session_token;
      state.common.birth = response.birth;
      state.common.is_parent_person = response.is_parent_person;
    },
    // 약관 목록 초기화
    INIT_TERMS_LIST(state) {
      state.term.integration = [];
      state.term.service = [];
    },
    SET_SERVICE_ID_TYPE(state, value) {
      state.serviceIdType = value;
      state.userType.selected = value;
    },
    // 약관 목록 설정
    SET_TERMS_LIST(state, response) {
      response.integration_terms.forEach((item) => (item.has_checked = false));
      response.service_terms.forEach((item) => (item.has_checked = false));

      state.term.integration = response.integration_terms;
      state.term.service = response.service_terms;
    },
    // 통합 약관 설정
    UPDATE_INTEGRATION_TERMS(state, termList) {
      state.term.integration = termList;
    },
    // 서비스 약관 설정
    UPDATE_SERVICE_TERMS(state, termList) {
      state.term.service = termList;
    },
    // 제한 나이 초기화
    INIT_AGE_LIMIT(state) {
      state.term.hasAgeLimit = undefined;
    },
    // 제한 나이 설정
    UPDATE_AGE_LIMIT(state, hasAgeLimit) {
      state.term.hasAgeLimit = hasAgeLimit;
    },
    // 법적 대리인 정보 저장
    UPDATE_PARENT_PHONE(state, phone) {
      state.account.parentPhone = phone;
    },
    // 법적 대리인 이름 저장
    UPDATE_PARENT_NAME(state, name) {
      state.account.parentName = name;
    },
    // 가입 유형 설정
    UPDATE_ACCOUNT_METHOD(state, method) {
      state.account.method = method;
    },
    // 계정 정보 설정 (점유인증)
    UPDATE_ACCOUNT_ID(state, payload) {
      state.account.id = payload.id;
      state.account.country_number = payload.country_number;
    },
    // 계정 정보 설정 (SNS)
    UPDATE_SOCIAL_DATA(state, payload) {
      state.account.id = payload.id;
      state.account.method = payload.method;
      state.account.social_data = payload.social_data;
    },
    INIT_SERVICE_INFORMATION(state) {
      state.account.password = "";
      state.account.service_information = {};
    },
    UPDATE_SERVICE_INFORMATION(state, payload) {
      state.account.password = payload.password;
      state.account.service_information = payload.service_information;
    },
    // 계정 정보 설정 (전환)
    UPDATE_TRANSFER_INFO(state, response) {
      state.transfer.id = response.local_id;
      state.transfer.method = response.local_id_type;
    },
    // 전환 결과 설정
    UPDATE_TRANSFER_RESULT(state, response) {
      state.account.id = response.id;
      state.account.is_multi = response.is_multi ?? false;
      state.account.method = response.method;
      state.account.muti_account_list = response.muti_account_list ?? [];
      state.account.password = response.password;
      state.account.social_data = response.social_data;
      // state.transfer.id = response.transfer_id;
      // state.transfer.method = response.transfer_method;
    },
    // 로그인한 유저 정보 설정
    UPDATE_USER_INFORMATION(state, response) {
      if (CommonUtil.isNotEmpty(response.phone_id)) {
        state.account.id = response.phone_id;
        state.account.method = ID_TYPE.PHONE;
      } else if (CommonUtil.isNotEmpty(response.email_id)) {
        state.account.id = response.email_id;
        state.account.method = ID_TYPE.EMAIL;
      } else {
        state.account.method = response.social_type;
      }
      state.account.birth = response.birth;
      state.account.userNo = response.member_no;
      state.account.name = response.name;
      state.account.nickname = response.nickname;
      state.account.phone = response.phone;
      state.account.email = response.email;
      state.account.parentPhone = response.parent_phone;
      state.account.parentName = response.parent_name;
    },
    UPDATE_DUPLICATION_INFO(state, response) {
      state.duplicationInfo = response;
    },
    // 통합 유저 정보 설정
    UPDATE_INTEGRATED_INFORMATION(state, response) {
      state.account.password = response.password;
    },
    // 유저 유형 목록 설정
    SET_USER_TYPE_LIST(state, response) {
      state.userType.list = response.member_service_type;
      state.userType.selected = "";
    },
    // 유저 유형 설정
    UPDATE_USER_TYPE(state, userType) {
      state.userType.selected = userType;
    },
    UPDATE_AGE_STATUS(state, underAge) {
      state.account.under_age = underAge;
    },
    SET_TEACHER_DISABLE(state, flag) {
      state.isTeacher = flag;
    }
  },
  actions: {
    // 공통
    //
    // 세션키 설정
    setSessionKey({ commit, getters }, payload) {
      const { hasService, ...param } = payload;
      const config = { headers: { "X-Client-Id": getters.getXClientInfo.ID }, timeout: 5000 };

      return RegisterAPI.getSessionKey(param, config).then((response) => {
        const data = response.data;
        if (data.code === 21000) {
          commit("SET_SESSION_KEY", { session_key: data.value.session_key, hasService });
          return data;
        } else {
          throw new APIError(data.code, data.message);
        }
      });
    },
    // 유저 유형 목록 조회
    selectUserTypeList({ state, commit, getters }) {
      const config = { headers: { "X-Client-Id": getters.clientInfo.ID, "X-Os-Code": getters.getOSCode } };

      return RegisterAPI.getServiceUserTypeList(config).then((response) => {
        const data = response.data;

        if (data.code === 21000) {
          if (state.isTeacher) {
            const filterUserTypeList = {
              member_service_type: data.value.member_service_type.filter(
                (userType) => userType.type !== USER_TYPE.DION.TEACHER
              )
            };

            commit("SET_USER_TYPE_LIST", filterUserTypeList);
          } else {
            commit("SET_USER_TYPE_LIST", data.value);
          }

          return data;
        } else {
          throw new APIError(data.code, data.message);
        }
      });
    },
    // 약관 목록 설정
    selectTermAgreeList({ commit, getters }, payload) {
      const config = { headers: { "X-Client-Id": getters.clientInfo.ID } };

      return RegisterAPI.getTermList(payload, config).then((response) => {
        const data = response.data;

        if (data.code === 21000) {
          const advertisementIndex = data.value.integration_terms.findIndex((item) => item.terms === "TTC010");
          const serviceAdvertisementIndex = data.value.service_terms.findIndex((item) => item.terms === "TTC113");

          data.value.integration_terms[advertisementIndex] = {
            ...data.value.integration_terms[advertisementIndex],
            sms_send_agree: false,
            email_send_agree: false,
            push_send_agree: false
          };

          data.value.service_terms[serviceAdvertisementIndex] = {
            ...data.value.service_terms[serviceAdvertisementIndex],
            sms_send_agree: false,
            email_send_agree: false,
            push_send_agree: false
          };

          commit("SET_TERMS_LIST", data.value);
        } else {
          throw new APIError(data.code, data.message);
        }
      });
    },
    // 유저 정보 조회
    selectUserInformation({ commit, getters }, payload) {
      const config = {
        headers: {
          "X-Client-Id": getters.getXClientInfo.ID,
          Authorization: payload.accessToken,
          "X-Client-Version": ENCRYPTION_VERSION,
          "X-Client-Service": commonUtil.getServiceMappingKey(getters.clientInfo.SERVICE_CODE)
        }
      };

      return RegisterAPI.getUserInfo(config).then((response) => {
        const data = response.data;
        if (data.code === 21000) {
          const value = { ...data.value };

          if (CommonUtil.isNotEmpty(value.name)) {
            value.name = EncryptionUtil.aes256Decrypt(value.name);
          }
          if (CommonUtil.isNotEmpty(value.phone)) {
            value.phone = EncryptionUtil.aes256Decrypt(value.phone);
          }
          if (CommonUtil.isNotEmpty(value.parent_phone)) {
            value.parent_phone = EncryptionUtil.aes256Decrypt(value.parent_phone);
          }
          if (CommonUtil.isNotEmpty(value.parent_name)) {
            value.parent_name = EncryptionUtil.aes256Decrypt(value.parent_name);
          }
          if (CommonUtil.isNotEmpty(value.nickname)) {
            value.nickname = EncryptionUtil.aes256Decrypt(value.nickname);
          }
          commit("UPDATE_USER_INFORMATION", value);
          window.dataLayer.push({ hashMemberNo: data.value.hash_member_no });
          window.dataLayer.push({ hashServiceMemberNo: data.value.hash_service_member_no });
          return data;
        } else {
          throw new APIError(data.code, data.message);
        }
      });
    },
    // 유저 아이디 중복 정보 조회
    getDuplicatedAccountInfo({ commit, getters }, payload) {
      const config = { headers: { "X-Client-Id": getters.getXClientInfo.ID } };

      return RegisterAPI.getDuplicatedAccountInfo(payload, config).then((response) => {
        const { data } = response;
        if (data.code === 21000) {
          commit("UPDATE_DUPLICATION_INFO", data.value);
          return data;
        } else {
          throw new APIError(data.code, data.message);
        }
      });
    },
    // 유저 추천 정보 조회
    selectUserRecommendInformation({ getters }, payload) {
      const { access_token, ...param } = payload;
      const serviceId = getters.clientInfo.SERVICE_ID;

      const config = {
        headers: {
          "X-Client-Id": getters.getXClientInfo.ID,
          Authorization: access_token,
          "X-Client-Version": ENCRYPTION_VERSION,
          "X-Client-Service": commonUtil.getServiceMappingKey(getters.clientInfo.SERVICE_CODE)
        }
      };

      return RegisterAPI.getUserRecommendInformation(serviceId, param, config).then((response) => {
        const data = response.data;
        if (data.code === 21000) {
          const value = { ...data.value };
          if (CommonUtil.isNotEmpty(value.name)) {
            value.name = EncryptionUtil.aes256Decrypt(value.name);
          }
          if (CommonUtil.isNotEmpty(value.nick_name)) {
            value.nick_name = EncryptionUtil.aes256Decrypt(value.nick_name);
          }
          if (CommonUtil.isNotEmpty(value.phone)) {
            value.phone = EncryptionUtil.aes256Decrypt(value.phone);
          }
          return value;
        } else {
          throw new APIError(data.code, data.message);
        }
      });
    },
    // 통합 회원가입
    //
    // 통합 유저 유형 등록
    insertUserType({ commit, getters }, param) {
      const config = { headers: { "X-Client-Id": getters.clientInfo.ID } };

      // 통합 회원가입 - 유저 유형 등록 API
      return RegisterAPI.insertRegisterUserType(param, config).then((response) => {
        const data = response.data;
        if (data.code === 21000) {
          commit("UPDATE_USER_TYPE", param.type);
          return data;
        } else {
          throw new APIError(data.code, data.message);
        }
      });
    },
    // 통합 약관 등록
    insertTermAgree({ getters }, payload) {
      const config = { headers: { "X-Client-Id": getters.clientInfo.ID } };
      const { hasTransfer, ...param } = payload;

      if (hasTransfer) {
        return TransferAPI.insertTransferTerm(param, config).then((response) => {
          const data = response.data;
          if (data.code === 21000) {
            return data;
          } else {
            throw new APIError(data.code, data.message);
          }
        });
      } else {
        return RegisterAPI.insertTerm(param, config).then((response) => {
          const data = response.data;
          if (data.code === 21000) {
            return data;
          } else {
            throw new APIError(data.code, data.message);
          }
        });
      }
    },
    // 통합 서비스 회원가입
    insertIntegratedRegister({ commit, getters }, payload) {
      const { hasTransfer, ...param } = payload;

      // inserTransferTerm
      if (hasTransfer) {
        const config = { headers: { "X-Client-Id": getters.clientInfo.ID, "X-Os-Code": getters.getOSCode } };
        return TransferAPI.insertTransferIntegratedRegister(param, config).then((response) => {
          const data = response.data;
          if (data.code === 21000) {
            commit("UPDATE_TRANSFER_INFO", data.value);
            commit("UPDATE_INTEGRATED_INFORMATION", { password: param.password });
            return data;
          } else {
            throw new APIError(data.code, data.message);
          }
        });
      } else {
        const config = {
          headers: {
            "X-Client-Id": getters.clientInfo.ID,
            "X-Os-Code": getters.getOSCode,
            "X-Client-Version": ENCRYPTION_VERSION,
            "X-Client-Service": commonUtil.getServiceMappingKey(getters.clientInfo.SERVICE_CODE)
          }
        };
        return RegisterAPI.insertIntegratedRegister(param, config).then((response) => {
          const data = response.data;
          if (data.code === 21000) {
            commit("UPDATE_INTEGRATED_INFORMATION", { password: param.password });
            return data;
          } else {
            throw new APIError(data.code, data.message);
          }
        });
      }
    },
    // 통합 서비스 SNS 회원가입
    insertIntegratedSocialRegister({ commit, getters }, payload) {
      const { hasTransfer, ...param } = payload;

      // inserTransferTerm
      if (hasTransfer) {
        const config = { headers: { "X-Client-Id": getters.clientInfo.ID, "X-Os-Code": getters.getOSCode } };
        return TransferAPI.insertTransferIntegratedSocialRegister(param, config).then((response) => {
          const data = response.data;
          if (data.code === 21000) {
            commit("UPDATE_TRANSFER_INFO", data.value);
            return data;
          } else {
            throw new APIError(data.code, data.message);
          }
        });
      } else {
        const config = {
          headers: {
            "X-Client-Id": getters.clientInfo.ID,
            "X-Os-Code": getters.getOSCode,
            "X-Client-Version": ENCRYPTION_VERSION,
            "X-Client-Service": commonUtil.getServiceMappingKey(getters.clientInfo.SERVICE_CODE)
          }
        };
        return RegisterAPI.insertIntegratedSocialRegister(param, config).then((response) => {
          const data = response.data;
          if (data.code === 21000) {
            return data;
          } else {
            throw new APIError(data.code, data.message);
          }
        });
      }
    },
    // 서비스 회원가입
    //
    // 서비스 유저 유형 등록
    insertServiceUserType({ commit, getters }, payload) {
      const { access_token, ...param } = payload;
      const config = { headers: { "X-Client-Id": getters.getXClientInfo.ID, Authorization: access_token } };

      const serviceId = getters.clientInfo.SERVICE_ID;
      return RegisterAPI.insertServiceUserType(serviceId, param, config).then((response) => {
        const data = response.data;
        if (data.code === 21000) {
          commit("UPDATE_USER_TYPE", param.type);
          return data;
        } else {
          throw new APIError(data.code, data.message);
        }
      });
    },
    // 서비스 약관 동의
    insertServiceTermAgree({ getters }, payload) {
      const { accessToken, service_id, ...param } = payload;
      const serviceId = CommonUtil.isNotEmpty(service_id) ? service_id : getters.clientInfo.SERVICE_ID;
      const config = { headers: { "X-Client-Id": getters.getXClientInfo.ID, Authorization: accessToken } };

      return RegisterAPI.insertServiceTerm(serviceId, param, config).then((response) => {
        const data = response.data;
        if (data.code === 21000) {
          return data;
        } else {
          throw new APIError(data.code, data.message);
        }
      });
    },
    // 서비스 등록
    insertServiceRegister({ getters }, payload) {
      const { access_token, service_id, ...param } = payload;
      const serviceId = CommonUtil.isNotEmpty(service_id) ? service_id : getters.clientInfo.SERVICE_ID;
      const config = {
        headers: {
          "X-Client-Id": getters.getXClientInfo.ID,
          Authorization: access_token,
          "X-Os-Code": getters.getOSCode,
          "X-Client-Version": ENCRYPTION_VERSION,
          "X-Client-Service": commonUtil.getServiceMappingKey(getters.clientInfo.SERVICE_CODE)
        }
      };

      return RegisterAPI.insertService(serviceId, param, config).then((response) => {
        const data = response.data;
        if (data.code === 21000) {
          return data;
        } else {
          throw new APIError(data.code, data.message);
        }
      });
    },
    // 전환 회원가입
    //
    // 전환 유저 생일 조회
    selectUserBirth({ commit, getters }, param) {
      const config = { headers: { "X-Client-Id": getters.clientInfo.ID, "X-Os-Code": getters.getOSCode } };

      return TransferAPI.getTransferUserBirth(param, config).then((response) => {
        const data = response.data;
        if (data.code === 21000) {
          commit("SET_TRANSFER_USER_INFO", data.value);
          return data;
        } else {
          throw new APIError(data.code, data.message);
        }
      });
    },
    // 전환 계정 여부 확인
    selectTransferAccountList({ getters }, payload) {
      const { access_token, ...param } = payload;
      const serviceId = getters.clientInfo.SERVICE_ID;
      const headers = {
        "X-Client-Id": getters.getXClientInfo.ID,
        Authorization: access_token
      };

      if (param.id_type === ID_TYPE.PHONE) {
        headers["X-Client-Version"] = ENCRYPTION_VERSION;
        headers["X-Client-Service"] = commonUtil.getServiceMappingKey(getters.clientInfo.SERVICE_CODE);
      }

      const config = { headers };

      return TransferAPI.getTransferAccountService(serviceId, param, config).then((response) => {
        const data = response.data;
        if (data.code === 21000) {
          return data;
        } else {
          throw new APIError(data.code, data.message);
        }
      });
    },
    // 14세 미만 여부 확인
    getAgeStatus({ commit, getters }, payload) {
      const { access_token } = payload;
      const headerOption = {
        Authorization: `bearer ` + access_token,
        "X-Client-Id": getters.getXClientInfo.ID
      };
      return RegisterAPI.getLegalCheck(headerOption)
        .then((value) => {
          const data = value.data;
          if (data.code === 21000) {
            const underAge = data.value === true;
            commit("UPDATE_AGE_STATUS", underAge);
          } else {
            throw new APIError(data.code, data.message);
          }
        })
        .catch((err) => {
          console.log("update age state err " + err);
        });
    },
    checkServiceIdType({ commit, getters }, payload) {
      const serviceId = getters.clientInfo.SERVICE_ID;
      const param = {
        session_key: payload.sessionKey
      };
      const config = {
        headers: {
          Authorization: `bearer ${payload.accessToken}`,
          "X-Client-Id": getters.getXClientInfo.ID
        }
      };
      return RegisterAPI.checkServiceIdType(serviceId, param, config)
        .then((res) => {
          const { code, message, value } = res.data;
          if (code === 21000) {
            commit("SET_SERVICE_ID_TYPE", value?.type || "");
          } else {
            throw new APIError(code, message);
          }
        })
        .catch((err) => {
          console.error("check service id type err " + err);
        });
    }
  }
};
